import { Injectable, signal, effect, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private platformId = inject(PLATFORM_ID);
  readonly darkMode = signal(false);

  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const saved = localStorage.getItem('darkMode');
      this.darkMode.set(saved === 'true');
      effect(() => {
        const dark = this.darkMode();
        if (dark) {
          document.documentElement.classList.add('app-dark');
        } else {
          document.documentElement.classList.remove('app-dark');
        }
        localStorage.setItem('darkMode', String(dark));
      });
    }
  }

  toggle() {
    this.darkMode.set(!this.darkMode());
  }
}
